import { ChainId } from '@decent.xyz/box-common';
import { Chain } from 'viem';
import { chains } from '../../services/wagmi/wagmiConfig';

const filterZoraSepoliaPredicate = (chain: Chain) => chain.id !== 999999999;

export const SUPPORTED_CHAINS = chains
  .filter(filterZoraSepoliaPredicate)
  .map(({ id, nativeCurrency }) => ({ value: id, token: nativeCurrency.symbol }));

export const CHAIN_DATA = {
  [ChainId.ARBITRUM]: {
    image: '/images/chains/arbitrum.png',
    name: 'Arbitrum',
  },
  [ChainId.ETHEREUM]: {
    image: '/images/chains/ethereum.png',
    name: 'Ethereum',
  },
  [ChainId.BNB]: {
    image: '/images/chains/bnb.png',
    name: 'BNB',
  },
  [ChainId.BASE]: {
    image: '/images/chains/base.png',
    name: 'Base',
  },
  [ChainId.OPTIMISM]: {
    image: '/images/chains/optimism.png',
    name: 'Optimism',
  },
  [ChainId.POLYGON]: {
    image: '/images/chains/polygon.png',
    name: 'Polygon',
  },
  [ChainId.ZORA]: {
    image: '/images/chains/zora.avif',
    name: 'Zora',
  },
  [ChainId.BASE_SEPOLIA]: {
    image: '/images/chains/base.png',
    name: 'Base Sepolia',
  },
  [ChainId.SEPOLIA]: {
    image: '/images/chains/zora.avif',
    name: 'Sepolia',
  },
  [ChainId.POLYGON_AMOY]: {
    image: '/images/chains/polygon.png',
    name: 'Polygon Amoy',
  },
  [ChainId.ZKSYNC]: {
    image: '/images/chains/zksync.png',
    name: 'zkSync Era',
  },
};
